module.exports = __webpack_public_path__ + "img/zw3.df9cdae3.webp";